// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Users_establishments__Iy56l","header":"Users_header__38sv1","tableHeader":"Users_tableHeader__3U-28"};